import { render } from "./verifyDoc.vue?vue&type=template&id=bd6ac0fc"
import script from "./verifyDoc.vue?vue&type=script&lang=js"
export * from "./verifyDoc.vue?vue&type=script&lang=js"

import "./verifyDoc.vue?vue&type=style&index=0&id=bd6ac0fc&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__